import { Routes } from '@angular/router';
import { ChangesNotSavedGuard } from '../../shared/components/changes-not-saved';
import { AuthGuard } from '../auth/guards';
import { ApplicationComponent } from './application.component';
import {
    ApplicationSubmittedComponent,
    BackgroundComponent,
    DisclosureComponent,
    PersonalInformationComponent,
    YourEducationComponent
} from './pages';
import { ApplicationEntryGuard } from './guards';
import { ApplicationConfirmationComponent } from './pages/application-confirmation/application-confirmation.component';

export const applicationRoutes: Routes = [
    {
        path: ':clientCode/application',
        component: ApplicationComponent,
        // ApplicationEntryGuard loads the application, attaches any staged provider selection and
        // redirects to the page the student belongs on — all before the flow renders, so every
        // page below sees an authoritative record (LA-22939).  A guard rather than a resolver
        // because only a guard can redirect.  On the parent, so it runs once per entry to the
        // flow rather than on every step the student takes.
        canActivate: [AuthGuard, ApplicationEntryGuard],
        children: [
            {
                path: 'personal-information',
                component: PersonalInformationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'background',
                component: BackgroundComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'your-education',
                component: YourEducationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'disclosure',
                component: DisclosureComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            { path: '', redirectTo: 'personal-information', pathMatch: 'full' }
        ]
    },
    {
        path: ':clientCode/application-submitted',
        component: ApplicationSubmittedComponent,
        canActivate: [AuthGuard]
    },
    {
        path: ':clientCode/application-confirmed',
        component: ApplicationConfirmationComponent,
        canActivate: [AuthGuard]
    }
];
